/**
 * Created by eliasmj on 24/01/2017.
 */
/**
 * Created by eliasmj on 06/01/2017.
 */
    angular.module('qkr.payment.gateway')
        .config(configPaymentGateway);

    configPaymentGateway.$inject = ['$routeSegmentProvider', 'appUrl'];

    function configPaymentGateway($routeSegmentProvider, appUrl) {

        $routeSegmentProvider
            .when('/paymentgateway', 'paymentgateway', { pageTitle: 'Payment Settings'});

        $routeSegmentProvider
            .segment('paymentgateway', {
                template: require('../../payment-gateway/templates/index.html')
            })
            .within()
            .segment('details', {
                template: require('../../payment-gateway/templates/paymentgateway.html')
            });
    }



// WEBPACK FOOTER //
// ./src/payment-gateway/config/payment.gateway.config.js